export enum StateSlice {
    AUTH = 'auth',
    API_KEYS = 'apiKeys',
    BILLING = 'billing',
    DELIVERY = 'delivery',
    DEVSUPPORT = 'dev-support',
    DRIVERS = 'drivers',
    ENTITY = 'entity',
    GLOBAL = 'global',
    INTERCOM = 'intercom',
    LIVEVIEW = 'live-view', 
    LOCATION = 'location', 
    PREFERENCE = 'preference',
    PROFILE = 'profile',
    REGISTRATION = 'registration',
    REPORTS = 'reports',
    ROUTER = 'router',
    SESSION = 'session',
    TOAST = 'toast',
    TRACKING = 'tracking',
    USERS = 'users'
}
  